/**
 * `auto_number` — a sequence number the board assigns; read-only, and monday returns **no
 * cell at all** for it (`[cvs§2 auto_number]`), so the grid renders the row's position with
 * the column's own prefix.
 */
import { getColumnType, type AutoNumberSettings, type AutoNumberValue } from '@elizmonday/shared';
import { defineColumnUi } from '../types';
import { AutoNumberSettingsDialog } from './SettingsDialog';

const shared = getColumnType('auto_number');

export const autoNumberColumnUi = defineColumnUi<AutoNumberValue, AutoNumberSettings>({
  type: 'auto_number',
  icon: 'columnNumbers',
  gallery: { group: 'numbers', keywords: ['auto number', 'sequence', 'counter', 'index'] },
  /** P-022: the registry default. ASSUMED — no `width: null` column of this type is measured. */
  defaultWidth: 140,
  align: 'right',
  groupable: false,

  Cell: ({ value, settings }) => {
    const text = shared.toText(value, settings) ?? '';
    if (text === '') return <span className="ez-cell__empty" aria-hidden="true" />;
    return (
      <span className="ez-cell__text" data-align="right">
        {text}
      </span>
    );
  },

  SettingsDialog: AutoNumberSettingsDialog,

  fromClipboard() {
    throw new Error('the auto number column is read-only');
  },
  toClipboard(value, settings) {
    return shared.toText(value, settings) ?? '';
  },
  bucketsOf() {
    return [];
  },
});
